import React, { useEffect, useCallback, useState} from 'react';
import {JAKI_FIGURES} from 'constants/pullable-types.js';
import PullablePart from "components/pulled/PullablePart.js";
import {setSelectedZObject} from 'actions/index.js';
import EffectParameterSlider from "components/effects/EffectParameterSlider.js";
import {FIGURE} from './constants.js';
import {parse, getCycleString} from 'effects/midi/tidal/parser.js';
import {connect} from 'react-redux';

const Figures = ({isDraggable, effect, zobject, setChosen, chosen, _figures, setSelectedZObject}) => { 
    let [figures, setFigures] = useState(effect.figures.figures);

    useEffect(() => {
        if (figures !== effect.figures.figures) {
            setFigures(effect.figures.figures);
        }
    }, [effect.figures, setFigures, figures]);

    const addFigure = useCallback(() => {
        effect.figures.newFigure();
        setFigures(effect.figures.figures);
    }, [setFigures]);

    return (
        <div>
          <PullablePart
            isDraggable={isDraggable}
            effect={effect}
            skipDiv={true}
            instrument={effect.figuresComponent}
            type={JAKI_FIGURES}
            className="figures">
            {figures.map(
              x =>
                  <div
                   className={chosen && chosen.figure === x ? "figure selected" : "figure"}>
                    <div
                      onClick={(e) => {
                          console.log('zobject=', zobject);
                          if (zobject) {
                              setSelectedZObject(zobject);
                          }
                          e.stopPropagation();
                          if (setChosen) {
                              if (chosen && chosen.type === FIGURE && chosen.figure === x) {
                                  setChosen(undefined);
                              } else {
                                  setChosen({
                                      type: FIGURE,
                                      figure: x
                                  });
                              }
                          }
                      }}
                      className="figure-button">
                      {Math.round(x.figureLength)}
                    </div>
                    <div className="cycle-string">
                      {x.toString()}
                    </div>
                  </div>)}
           <dig className="figure">
            <div onClick={addFigure} className="figure-button add">
              +
            </div>
          </dig>
        </PullablePart>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      _figures: props.effect.figures._figures
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedZObject: x => dispatch(setSelectedZObject(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Figures);
